import {useEffect} from "react";
import {Link, useLocation} from "react-router-dom";
import './style.scss';

const Nav = () => {
    const location = useLocation();

    useEffect(() => {
        const nav = document.querySelector('.nav');
        if (!nav || location.pathname === '/') return undefined;

        const updateBackground = () => {
            nav.classList.toggle('nav-background', window.scrollY > 0);
        };

        updateBackground();
        window.addEventListener('scroll', updateBackground, {passive: true});

        return () => {
            window.removeEventListener('scroll', updateBackground);
            nav.classList.remove('nav-background');
        };
    }, [location.pathname]);

    const links = [
        {path:'/#cinematography', name: 'Cinematography'},
        {path:'/#dance', name: 'Dance'},
        {path:'/#exhibition', name: 'Exhibitions'},
        {path:'/#directing', name: 'Directing'},
        {path:'/#private-projects', name: 'Private Projects'},
        {path:'/#bio', name: 'Bio'},
        {path:'/#contact', name: 'Contact'},
    ];

    const scrollToHomeAnchor = event => {
        if (location.pathname !== '/') return;

        const anchor = event.currentTarget.getAttribute('href').split('#')[1];
        const target = document.getElementById(anchor);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    return (
        <div className='nav'>
            <ul className='links'>
                {links.map(link => (
                    <li key={link.name}>
                        <Link
                            to={link.path}
                            onClick={link.path.startsWith('/#') ? scrollToHomeAnchor : undefined}
                        >
                            {link.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Nav;
